// Metagenomica.jsx
import style from './Metagenomica.module.css';
import './Metagenomica.css';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { TemaContext } from '../../common/context/TemaContext';
import { LinguagemContext } from '../../common/context/LinguagemContext';
import { UsuarioContext } from '../../common/context/UsuarioContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Translator from '../I18n/Translator';
import L from 'leaflet';
import { TextField, Autocomplete, FormControl, InputLabel, Select, MenuItem, Chip, OutlinedInput, Stack } from '@mui/material';
import moment from 'moment';
import chroma from 'chroma-js';
import CancelIcon from "@mui/icons-material/Cancel";
import * as XLSX from 'xlsx';
import TabNav from '../TabNav';
import CookieService from '../../service/CookieService';
import { ServerContext } from '../../common/context/ServerContext';
import { feature } from 'topojson-client';
import { fetchWithMemoryCache } from "../../service/MemoryCache";
import 'leaflet.glify'; // mantém compatibilidade se você quiser usar depois

// ---------------------------------------------------------------
// Utilidades e constantes
// ---------------------------------------------------------------
const cod_estados = [
  {"UF":"AC","COD":12,"NOME":"Acre"},{"UF":"AL","COD":27,"NOME":"Alagoas"},
  {"UF":"AP","COD":16,"NOME":"Amapá"},{"UF":"AM","COD":13,"NOME":"Amazonas"},
  {"UF":"BA","COD":29,"NOME":"Bahia"},{"UF":"CE","COD":23,"NOME":"Ceará"},
  {"UF":"DF","COD":53,"NOME":"Distrito Federal"},{"UF":"ES","COD":32,"NOME":"Espírito Santo"},
  {"UF":"GO","COD":52,"NOME":"Goiás"},{"UF":"MA","COD":21,"NOME":"Maranhão"},
  {"UF":"MT","COD":51,"NOME":"Mato Grosso"},{"UF":"MS","COD":50,"NOME":"Mato Grosso do Sul"},
  {"UF":"MG","COD":31,"NOME":"Minas Gerais"},{"UF":"PA","COD":15,"NOME":"Pará"},
  {"UF":"PB","COD":25,"NOME":"Paraíba"},{"UF":"PR","COD":41,"NOME":"Paraná"},
  {"UF":"PE","COD":26,"NOME":"Pernambuco"},{"UF":"PI","COD":22,"NOME":"Piauí"},
  {"UF":"RJ","COD":33,"NOME":"Rio de Janeiro"},{"UF":"RN","COD":24,"NOME":"Rio Grande do Norte"},
  {"UF":"RS","COD":43,"NOME":"Rio Grande do Sul"},{"UF":"RO","COD":11,"NOME":"Rondônia"},
  {"UF":"RR","COD":14,"NOME":"Roraima"},{"UF":"SC","COD":42,"NOME":"Santa Catarina"},
  {"UF":"SP","COD":35,"NOME":"São Paulo"},{"UF":"SE","COD":28,"NOME":"Sergipe"},
  {"UF":"TO","COD":17,"NOME":"Tocantins"}
];

const baseColors = ["#FFA500", "#FFFF00", "#00FF00", "#00CED1", "#1E90FF", "#00008B"]; // paleta base
const position = [-15.0, -54.27390005057997];
const defaultZoom = 3;
const zoomSnap_ = 0.25;
const wheelPxPerZoomLevel_ = 120;

const estados_labels_iniciais = [
  {label:"Todos"},
  {label:"Acre"},{label:"Alagoas"},{label:"Amapá"},{label:"Amazonas"},
  {label:"Bahia"},{label:"Ceará"},{label:"Distrito Federal"},{label:"Espírito Santo"},
  {label:"Goiás"},{label:"Maranhão"},{label:"Mato Grosso"},{label:"Mato Grosso do Sul"},
  {label:"Minas Gerais"},{label:"Pará"},{label:"Paraíba"},{label:"Paraná"},{label:"Pernambuco"},
  {label:"Piauí"},{label:"Rio de Janeiro"},{label:"Rio Grande do Norte"},{label:"Rio Grande do Sul"},
  {label:"Rondônia"},{label:"Roraima"},{label:"Santa Catarina"},{label:"São Paulo"},{label:"Sergipe"},{label:"Tocantins"},
];

function isNumeric(v){ return /^\d+(?:\.\d+)?$/.test(v); }
function FormatarDoisDigitos(n){ if(n===null||n===undefined) return "00"; return n.toString().padStart(2,'0'); }

// estatística
function percentile(arr, p) {
  if (!arr?.length) return null;
  const sortedArr = arr.slice().sort((a,b)=>a-b);
  const index = (p/100)*(sortedArr.length-1);
  const lower = Math.floor(index);
  const upper = Math.ceil(index);
  if (lower === upper) return sortedArr[index];
  const w = index - lower;
  return sortedArr[lower]*(1-w) + sortedArr[upper]*w;
}
function quintile(arr) {
  return [20,40,60,80].map(q=>percentile(arr,q));
}

// curva (bezier) p/ rotas
function calculateControlPoint(lat1, lon1, lat2, lon2, curvatura = 0.3) {
  const lat_mid = (lat1 + lat2) / 2;
  const lon_mid = (lon1 + lon2) / 2;
  const dx = lon2 - lon1;
  const dy = lat2 - lat1;
  const distance = Math.sqrt(dx*dx + dy*dy);
  const perp_dx = -dy, perp_dy = dx;
  const magnitude = Math.sqrt(perp_dx*perp_dx + perp_dy*perp_dy);
  const offset_x = (perp_dx / magnitude) * distance * curvatura;
  const offset_y = (perp_dy / magnitude) * distance * curvatura;
  return [lat_mid + offset_y, lon_mid + offset_x];
}
function bezierCurve(start, control, end, segments = 200) {
  const curve = [];
  for (let i=0;i<=segments;i++) {
    const t = i/segments;
    const x = Math.pow(1-t,2)*start[0] + 2*(1-t)*t*control[0] + Math.pow(t,2)*end[0];
    const y = Math.pow(1-t,2)*start[1] + 2*(1-t)*t*control[1] + Math.pow(t,2)*end[1];
    curve.push([x,y]);
  }
  return curve;
}

// ---------------------------------------------------------------
// Componente
// ---------------------------------------------------------------
var _logado = "";
const Metagenomica = () => {
  const { theme } = useContext(TemaContext);
  const { language } = useContext(LinguagemContext);
  const { logado, setLogado } = useContext(UsuarioContext);
  const { servidor } = useContext(ServerContext);

  const { t } = useTranslation();
  const navigate = useNavigate();

  // mapa/leaflet
  const map = useRef(null);
  const layerTile = useRef(null);
  const shapeFileBrasil = useRef(null);
  const shapeFileMunicipios = useRef(null);

  // renderers e grupos OTIMIZADOS
  const canvasRendererRef = useRef(null);
  const circleLayerRef = useRef(null);
  const origemCircleLayerRef = useRef(null);
  const polylineLayerRef = useRef(null);

  // índices rápidos para lookup
  const muniLayerIndexRef = useRef(new Map()); // CD_MUN -> layer
  const ufLayerIndexRef   = useRef(new Map()); // CD_UF  -> layer

  // estados
  const [geojsonBrasil, setGeojsonBrasil] = useState(null);
  const [geojsonMunicipios, setGeojsonMunicipios] = useState(null);
  const [carregouShapeFiles, setCarregouShapeFiles] = useState(false);
  const [loading, setLoading] = useState(true);

  const [dadosGenomica, setDadosGenomica] = useState(null);
  const [dadosUFGenomica, setDadosUFGenomica] = useState(null);
  const [dadosOrigemDestino, setDadosOrigemDestino] = useState(null);

  const [listaEstados, setListaEstados] = useState(null);
  const [listaMunicipios, setListaMunicipios] = useState([{ cod_ibge: 0, municipio: t("dashboard.todos") }]);
  const [cidades_labels, setCidades_Labels] = useState([{cod_ibge: t("dashboard.todos"), label: t("dashboard.todos")}]);

  const [estadoSelecionado, setEstadoSelecionado] = useState(t("dashboard.todos"));
  const [municipioSelecionado, setMunicipioSelecionado] = useState(t("dashboard.todos"));
  const [cod_ibge, setCod_Ibge] = useState(t("dashboard.todos"));

  const [semanaEp, setSemanaEp] = useState("");
  const [dadosTabRank, setDadosTabRank] = useState([]);

  const [indice, setIndice] = useState("mob"); // só "mob" utilizado
  const [selectedRank, setSelectedRank] = useState([
    t("dashboard.mobilidade"),
    t("dashboard.densidade"),
    "IBP",
    "DSEI"
  ]);

  const [campoOrdem, setCampoOrdem] = useState("rank_mob_den_ibp_dsei");
  const [decrescente, setDecrescente] = useState(false);
  const [campoOrdemOrigemDestino, setCampoOrdemOrigemDestino] = useState("estado_origem");
  const [decrescenteOrigemDestino, setDecrescenteOrigemDestino] = useState(false);

  const [dataCache, setDataCache] = useState(null);

  const legend = useRef(null);
  const cacheCores = useRef([]);
  const data_colormap = useRef([]);
  const todasCidades = useRef([]);

  const iniciou = useRef(false);
  const transparencia = useRef(0.5);
  const opacidadeMunicipio = 1.0;
  let weightNormal = theme === "dark" ? 0.5 : 0.3;
  const weightSelecao = 2.5;

  const transparenciaDefaultMapa = useMemo(() => "rgba(255, 255, 255, 0)", []);
  const cinzaDefaultMapaDark = useMemo(() => "#272727", []);
  const cinzaDefaultMapaBorda = useMemo(() => "#C1c3c3", []);

  // ---------------------------------------------------------------
  // Helpers que agora usam os índices (sem _layers)
  // ---------------------------------------------------------------
  const getNomeEUFCidadeWhereCodIbge = (cd) => {
    const layer = muniLayerIndexRef.current.get(String(cd));
    return layer ? [layer.feature.properties.NM_MUN, layer.feature.properties.SIGLA_UF] : [cd, ""];
  };
  const getNomeCidadeWhereCodIbge = (cd) => {
    const layer = muniLayerIndexRef.current.get(String(cd));
    return layer ? layer.feature.properties.NM_MUN : cd;
  };
  const getNomeEstadoByCodIbge = (cdUF) => {
    const layer = ufLayerIndexRef.current.get(String(cdUF));
    return layer ? layer.feature.properties.NM_UF : cdUF;
  };
  const getCodEstadoBySigla = (sigla) => {
    for (const e of cod_estados) if (e.UF === sigla) return e.COD;
    return 0;
  };
  const isAllSelect = (v) => v === "All" || v === "Todos" || v === t("dashboard.todos");

  // ---------------------------------------------------------------
  // Carrega/Indexa TopoJSON e cria camadas
  // ---------------------------------------------------------------
  async function loadGeoJSONData() {
    try {
      let brasilTopo = await fetchWithMemoryCache('brasilTopoJSON', 'flu/Dados/topojson/BR_UF_2022.json');
      let munisTopo  = await fetchWithMemoryCache('municipiosTopoJSON', 'flu/Dados/topojson/BR_Municipios_2022.json');

      const brasilData = feature(brasilTopo, brasilTopo.objects.BR_UF_2022);
      const municipiosData = feature(munisTopo, munisTopo.objects.BR_Municipios_2022);

      setGeojsonBrasil(brasilData);
      setGeojsonMunicipios(municipiosData);

      if (!shapeFileBrasil.current) {
        shapeFileBrasil.current = L.geoJSON(brasilData, {
          interactive: false,
          style: () => ({ color: "black", fillColor: transparenciaDefaultMapa, stroke: true, weight: weightNormal, fillOpacity: transparencia.current })
        });
      }
      if (!shapeFileMunicipios.current) {
        shapeFileMunicipios.current = L.geoJSON(municipiosData, {
          style: () => ({ color: "gray", fillColor: transparenciaDefaultMapa, stroke: true, weight: weightNormal, fillOpacity: opacidadeMunicipio }),
          onEachFeature: onEachFeatureEstado
        });
      }

      if (map.current) {
        shapeFileBrasil.current.addTo(map.current);
        shapeFileMunicipios.current.addTo(map.current);
      }

      // indexa
      muniLayerIndexRef.current.clear();
      shapeFileMunicipios.current.eachLayer((layer) => {
        const cd = String(layer?.feature?.properties?.CD_MUN ?? "");
        if (cd) muniLayerIndexRef.current.set(cd, layer);
      });

      ufLayerIndexRef.current.clear();
      shapeFileBrasil.current.eachLayer((layer) => {
        const cd = String(layer?.feature?.properties?.CD_UF ?? "");
        if (cd) ufLayerIndexRef.current.set(cd, layer);
      });

      setCarregouShapeFiles(true);
    } catch (err) {
      console.error("Erro ao carregar TopoJSON:", err);
    }
  }

  // ---------------------------------------------------------------
  // Mapa - Init
  // ---------------------------------------------------------------
  useEffect(() => {
    // autenticação básica
    //_logado = logado;

    if (CookieService.getCookie("hashCache")) _logado = CookieService.getCookie("hashCache");
    else {
      navigate("/");
      return;
    }
    
    setLogado(_logado);

    // cria tile layer
    const url = theme === "dark"
      ? "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}"
      : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";

    layerTile.current = L.tileLayer(url, {
      zoomControl: true, zoomSnap: zoomSnap_, zoomDelta: zoomSnap_,
      wheelPxPerZoomLevel: wheelPxPerZoomLevel_, defaultZoom, maxZoom: 18
    });

    if (!map.current) {
      map.current = L.map("map", {
        minZoom: 4,
        maxZoom: 10,
        layers: [layerTile.current]
      });
      // pane para circles acima
      const PANE = 'topPane';
      if (!map.current.getPane(PANE)) {
        const pane = map.current.createPane(PANE);
        pane.style.pointerEvents = 'none';
      }
      map.current.getPane('topPane').style.zIndex = 650;

      const { innerWidth: width } = window;
      if (width < 1300) map.current.setView([-13.338793, -45.206666], defaultZoom);
      else map.current.setView(position, defaultZoom);

      // renderer e grupos
      if (!canvasRendererRef.current) canvasRendererRef.current = L.canvas({ padding: 0.5 });
      if (!circleLayerRef.current) circleLayerRef.current = L.layerGroup().addTo(map.current);
      if (!origemCircleLayerRef.current) origemCircleLayerRef.current = L.layerGroup().addTo(map.current);
      if (!polylineLayerRef.current) polylineLayerRef.current = L.layerGroup().addTo(map.current);
    }

    // carregar shapes
    loadGeoJSONData();

    // carregar estados
    getEstadosAsync(_logado);

    // dados
    fetch(servidor + '/api/genomic/municipio', {
      headers: { 'Content-Type':'application/json','Accept':'application/json','Authorization':`Bearer ${_logado}` }
    })
    .then(r => { if (r.status === 401 || r.status === 404) { console.log("erro /api/genomic/municipio"); setLogado(null); window.location.href="/"; } return r.json(); })
    .then(data => {
      setDadosGenomica(data);
      setDadosTabRank(data);
      setSemanaEp(data?.[0] ? (data[0].epiweek + "-" + data[0].epiyear) : "");
    })
    .catch(console.error);

    fetch(servidor + "/api/genomic/oridesmunilast", {
      headers: { 'Content-Type':'application/json','Accept':'application/json','Authorization':`Bearer ${_logado}` }
    })
    .then(r => { if (r.status === 401 || r.status === 404) {console.log("erro /api/genomic/oridesmunilast");  setLogado(null); window.location.href="/"; } return r.json(); })
    .then(setDadosOrigemDestino)
    .catch(console.error);

    fetch(servidor + '/api/genomic/uf', {
      headers: { 'Content-Type':'application/json','Accept':'application/json','Authorization':`Bearer ${_logado}` }
    })
    .then(r => { if (r.status === 401 || r.status === 404) {console.log("erro /api/genomic/uf"); setLogado(null); window.location.href="/"; } return r.json(); })
    .then(data => { setDadosUFGenomica(data); setLoading(false); })
    .catch(console.error);

    // lista todas cidades (fallback coordenadas)
    fetch('Dados/lista_municipios/lista_municipios_todos.json?', {
      headers: { 'Content-Type':'application/json','Accept':'application/json' }
    })
    .then(r => r.json())
    .then(json => { todasCidades.current = json || []; })
    .catch(console.error);

    iniciou.current = true;
    localStorage.setItem('posicaoScroll', JSON.stringify(0));
    setDataCache(localStorage.getItem('dataCacheFiles'));

    // cleanup
    return () => {
      try { map.current?.off(); } catch {}
      try { map.current?.remove(); } catch {}
      map.current = null;

      window.onscroll = null;
      legend.current && legend.current._map && legend.current.remove();
      legend.current = null;

      shapeFileMunicipios.current = null;
      shapeFileBrasil.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // troca só o tile quando tema muda
  useEffect(() => {
    if (!map.current) return;
    if (layerTile.current) map.current.removeLayer(layerTile.current);
    const url = theme === "dark"
      ? "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}"
      : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";
    layerTile.current = L.tileLayer(url, {
      zoomControl: true, zoomSnap: zoomSnap_, zoomDelta: zoomSnap_,
      wheelPxPerZoomLevel: wheelPxPerZoomLevel_, defaultZoom, maxZoom: 18
    });
    layerTile.current.addTo(map.current);
    carregaCircles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  // aplica i18n em rótulos
  useEffect(() => {
    if (isAllSelect(estadoSelecionado)) setEstadoSelecionado(t("dashboard.todos"));
    if (isAllSelect(municipioSelecionado)) {
      setListaMunicipios([{ cod_ibge: 0, municipio: t("dashboard.todos") }]);
      setMunicipioSelecionado(t("dashboard.todos"));
      setCidades_Labels([{ cod_ibge: t("dashboard.todos"), label: t("dashboard.todos") }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  // rendezirar círculos quando dados/seleções mudam
  useEffect(() => {
    cacheCores.current = [];
    carregaCircles();
    if (campoOrdem.includes("rank")) setCampoOrdem(getNomeCampoIndice());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dadosGenomica, dadosUFGenomica, indice, selectedRank, estadoSelecionado]);

  // zoom -> re-render com debounce por frame
  useEffect(() => {
    if (!map.current) return;
    let raf = null;
    const onZoom = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => carregaCircles());
    };
    map.current.on('zoomend', onZoom);
    return () => {
      if (!map.current) return;
      map.current.off('zoomend', onZoom);
      if (raf) cancelAnimationFrame(raf);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, dadosGenomica, dadosUFGenomica, indice, selectedRank, estadoSelecionado, theme]);

  // ---------------------------------------------------------------
  // Estados (lista) - assíncrono e correto
  // ---------------------------------------------------------------
  async function getEstadosAsync(_logadoParam) {
    try {
      const resp = await fetch(servidor + '/api/estado', {
        headers: {
          'Content-Type':'application/json',
          'Accept':'application/json',
          'Authorization': `Bearer ${_logadoParam}`
        }
      });
      if (resp.status === 401 || resp.status === 404) {
        console.log("erro /api/estado");
        setLogado(null);
        window.location.href = "/";
        return;
      }
      const data = await resp.json();
      const items = data.map(d => ({ UF: d.UF, ESTADO: d.ESTADO }));
      items.unshift({ UF: "All", ESTADO: t("dashboard.todos") });
      setListaEstados(items);
    } catch(e) {
      console.error("Erro ao carregar estados:", e);
      setListaEstados([{ UF:"All", ESTADO:t("dashboard.todos") }]);
    }
  }

  // ---------------------------------------------------------------
  // UI/combos
  // ---------------------------------------------------------------
  const defaultProps = {
    options: estados_labels_iniciais.map(x => x.label === "Todos" ? {label: t("dashboard.todos")} : x),
    getOptionLabel: (option) => option.label,
  };
  const defaultPropsMunicipio = {
    options: cidades_labels,
    getOptionLabel: (option) => option.label,
  };

  function handleChangeMunicipioNome(cod) {
    if (!map.current) return;
    map.current.closePopup();
    if (isAllSelect(cod)) {
      // reset estilos
      if (shapeFileMunicipios.current) {
        shapeFileMunicipios.current.eachLayer((layer) => {
          const border = layer.options.color === "#dddcdf" ? "black" : layer.options.color;
          layer.setStyle({ weight: weightNormal, color: border, fillOpacity: 1.0 });
        });
      }
      setCod_Ibge(cod);
      setMunicipioSelecionado(getNomeCidadeWhereCodIbge(cod));
      localStorage.setItem('estadoSelecionadoDashboard', estadoSelecionado);
      localStorage.setItem('codibgeMunicipioSelecionadoDashboard', cod);
      localStorage.setItem('municipioSelecionadoDashboard', getNomeCidadeWhereCodIbge(cod));
      return;
    }
    setCod_Ibge(cod);
    setMunicipioSelecionado(getNomeCidadeWhereCodIbge(cod));
    localStorage.setItem('estadoSelecionadoDashboard', estadoSelecionado);
    localStorage.setItem('codibgeMunicipioSelecionadoDashboard', cod);
    localStorage.setItem('municipioSelecionadoDashboard', getNomeCidadeWhereCodIbge(cod));

    const layer = muniLayerIndexRef.current.get(String(cod));
    if (layer) {
      layer.setStyle({ weight: weightSelecao, color: "black", fillOpacity: opacidadeMunicipio });
      map.current.fitBounds(layer.getBounds().pad(1));
    }
  }

  function handleChangeEstadoTabela(estado) {
    setEstadoSelecionado(estado);
    setCod_Ibge(t("dashboard.todos"));
    setMunicipioSelecionado(t("dashboard.todos"));
    localStorage.setItem('estadoSelecionadoDashboard', estado);
    localStorage.setItem('codibgeMunicipioSelecionadoDashboard', t("dashboard.todos"));
    localStorage.setItem('municipioSelecionadoDashboard', t("dashboard.todos"));
  }
  function handleChangeMunicipioTabela(cod) {
    if (!map.current) return;
    map.current.closePopup();
    if (!isAllSelect(estadoSelecionado)) {
      setCod_Ibge(String(cod));
      setMunicipioSelecionado(getNomeCidadeWhereCodIbge(String(cod)));
      const layer = muniLayerIndexRef.current.get(String(cod));
      if (layer) {
        layer.setStyle({ weight: weightSelecao, color:"black", fillOpacity: 1.0 });
        map.current.fitBounds(layer.getBounds().pad(1));
      }
    } else {
      // descobre UF pela raiz do IBGE
      let ufEstado = "";
      for (const e of cod_estados) {
        if (String(cod).startsWith(String(e.COD))) { ufEstado = e.UF; break; }
      }
      if (ufEstado && listaEstados) {
        const item = listaEstados.find(x => x.UF === ufEstado);
        if (item) setTimeout(()=> setEstadoSelecionado(item.ESTADO), 600);
      }
    }
  }

  // ---------------------------------------------------------------
  // Carrega municípios por UF (popular combos)
  // ---------------------------------------------------------------
  function carregaMunicipiosPorEstado(sigla) {
    _logado = logado;
    if (CookieService.getCookie("hashCache")) _logado = CookieService.getCookie("hashCache");

    if (!sigla) return;
    fetch(servidor + '/api/municipio/municipiosbysiglaestado/' + sigla, {
      headers: {
        'Content-Type':'application/json',
        'Accept':'application/json',
        'Authorization': `Bearer ${_logado}`
      }
    })
    .then(r => r.json())
    .then(myJson => {
      const listaTemp = myJson.map(m => ({
        cod_ibge: m.cod_ibge, municipio: m.municipio, latitude: m.y, longitude: m.x
      }));
      const cidades_labels_tmp = [{ cod_ibge: 0, label: t("dashboard.todos") }]
        .concat(myJson.map(m => ({ cod_ibge: m.cod_ibge, label: m.municipio })));

      listaTemp.sort((a,b)=> a.municipio.localeCompare(b.municipio));
      listaTemp.unshift({ cod_ibge: 0, municipio: t("dashboard.todos") });

      setCidades_Labels(cidades_labels_tmp);
      setListaMunicipios(listaTemp);
    })
    .catch(console.error);
  }

  // ---------------------------------------------------------------
  // Tooltips e click por feature (sem _layers)
  // ---------------------------------------------------------------
  function onEachFeatureEstado(feature, layer) {
    layer.on('click', () => {
      if (!feature?.properties) return;
      setLoading(true);
      const sigla = feature.properties.SIGLA_UF;
      const cdUF  = getCodEstadoBySigla(sigla);
      const nome  = getNomeEstadoByCodIbge(cdUF);

      if (estadoSelecionado !== nome) carregaMunicipiosPorEstado(sigla);

      setEstadoSelecionado(nome);
      setMunicipioSelecionado(feature.properties.NM_MUN);
      setCod_Ibge(String(feature.properties.CD_MUN));

      localStorage.setItem('estadoSelecionadoDashboard', nome);
      localStorage.setItem('codibgeMunicipioSelecionadoDashboard', String(feature.properties.CD_MUN));
      localStorage.setItem('municipioSelecionadoDashboard', feature.properties.NM_MUN);

      layer.setStyle({ weight: weightSelecao, color: "black", fillOpacity: opacidadeMunicipio });
      map.current.fitBounds(layer.getBounds().pad(1));
      setTimeout(() => setLoading(false), 80);
    });
  }

  // ---------------------------------------------------------------
  // Ordenações/Render de tabelas
  // ---------------------------------------------------------------
  const preparaInt = (val) => {
    if (val === null || val === "" || val === "NaN" || val === t("dashboard.no_data")) return t("dashboard.no_data");
    return (val+"").replace(".","").replace(",","");
  };

  const getNomeCampoIndice = () => {
    // seleção dinâmica para colunas de rank
    if (selectedRank.length === 4) return "rank_mob_den_ibp_dsei";
    const hasDen  = selectedRank.includes(t("dashboard.densidade"));
    const hasIBP  = selectedRank.includes("IBP");
    const hasDSEI = selectedRank.includes("DSEI");

    if (hasDen && hasIBP && !hasDSEI) return "rank_mob_den_ibp";
    if (hasDen && hasDSEI && !hasIBP) return "rank_mob_den_dsei";
    if (hasIBP && hasDSEI && !hasDen) return "rank_mob_ibp_dsei";
    if (hasDen && !hasIBP && !hasDSEI) return "rank_mob_den";
    if (hasIBP && !hasDen && !hasDSEI) return "rank_mob_ibp";
    if (hasDSEI && !hasDen && !hasIBP) return "rank_mob_dsei";
    return "rank_mob";
  };

  function tabelaOrdenada() {
    if (!Array.isArray(dadosTabRank) || !dadosTabRank.length) return [];
    const tM = [...dadosTabRank];
    for (const r of tM) {
      const icodUF = parseInt(String(r.cod_ibge).substring(0,2));
      r.municipio = getNomeCidadeWhereCodIbge(r.cod_ibge);
      r.estado = getNomeEstadoByCodIbge(icodUF);
      if (r.dqi === null) r.dqi = "Não Apto";
    }
    const campo = campoOrdem;
    if (["municipio","estado","dqi"].includes(campo)) {
      tM.sort((a,b) => decrescente ? b[campo].localeCompare(a[campo]) : a[campo].localeCompare(b[campo]));
    } else {
      tM.sort((a,b)=> decrescente ? (a[campo]>b[campo]?-1:1) : (a[campo]>b[campo]?1:-1));
    }
    return tM;
  }

  function tabelaOrdenadaOrigemDestino() {
    if (!carregouShapeFiles || !Array.isArray(dadosOrigemDestino) || !dadosOrigemDestino.length) return [];
    let tM = [];
    if (!isAllSelect(estadoSelecionado)) {
      tM = dadosOrigemDestino.filter(d => d.estado_origem === estadoSelecionado);
    } else {
      tM = [...dadosOrigemDestino];
    }
    for (const it of tM) {
      let icodUF = parseInt(String(it.cod_ibge_muni).substring(0,2));
      it.municipio_destino = getNomeCidadeWhereCodIbge(it.cod_ibge_muni);
      it.cod_ibge_destino = it.cod_ibge_muni;
      it.estado_destino = getNomeEstadoByCodIbge(icodUF);

      icodUF = parseInt(String(it.ori_co_ibge).substring(0,2));
      it.municipio_origem = getNomeCidadeWhereCodIbge(it.ori_co_ibge);
      it.cod_ibge_origem = it.ori_co_ibge;
      it.estado_origem = getNomeEstadoByCodIbge(icodUF);
    }

    const campo = campoOrdemOrigemDestino;
    if (["municipio_origem","municipio_destino","estado_origem","estado_destino"].includes(campo)) {
      tM.sort((a,b)=> decrescenteOrigemDestino ? b[campo].localeCompare(a[campo]) : a[campo].localeCompare(b[campo]));
    } else {
      tM.sort((a,b)=> decrescenteOrigemDestino ? (a[campo]>b[campo]?-1:1) : (a[campo]>b[campo]?1:-1));
    }
    return tM;
  }

  // ---------------------------------------------------------------
  // Exportações
  // ---------------------------------------------------------------
  function cleanTableData (table) {
    const cells = table.querySelectorAll('td');
    cells.forEach(cell => cell.textContent = cell.textContent.replace(/↑/g,''));
  }
  function exportToExcel(nomeTabela, nomeArquivo) {
    const htmlTable = document.getElementById(nomeTabela);
    if (!htmlTable) return;
    const tableCopy = htmlTable.cloneNode(true);
    cleanTableData(tableCopy);

    let dataSelecionada = new Date().toLocaleString('pt-BR', { timeZone:'UTC' }).replace(/\//g,"-").substring(0,10);
    let nomeArquivoLocal = (dataSelecionada.replace(" ", "").replace(/-/g,"_")).replace("00:00:00","");
    const wb = XLSX.utils.table_to_book(tableCopy);
    XLSX.writeFile(wb, `tabela_${nomeArquivoLocal}_${nomeArquivo}.xlsx`);
  }
  function exportToCSV(nomeTabela, nomeArquivo) {
    const htmlTable = document.getElementById(nomeTabela);
    if (!htmlTable) return;
    const rows = htmlTable.querySelectorAll('tr');
    let csv = '';
    for (const row of rows) {
      const cells = row.querySelectorAll('th,td');
      const rowData = Array.from(cells).map(cell => cell.textContent.replace('↑',''));
      csv += rowData.join(',') + '\n';
    }
    let dataSelecionada = new Date().toLocaleString('pt-BR', { timeZone:'UTC' }).replace(/\//g,"-").substring(0,10);
    let nomeArquivoLocal = dataSelecionada.replace(" ", "").replace(/-/g,"_").replace("00:00:00","");
    const blob = new Blob([csv], { type:'text/csv;charset=iso-8859-1;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `tabela_${nomeArquivoLocal}_${nomeArquivo}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
  }

  // ---------------------------------------------------------------
  // Cores/Legenda
  // ---------------------------------------------------------------
  function getColorForValue(value, min, max) {
    const color_scale = chroma.scale(baseColors);
    const [q1,q2,q3,q4] = [data_colormap.current?.q1?.valor, data_colormap.current?.q2?.valor, data_colormap.current?.q3?.valor, data_colormap.current?.q4?.valor];
    const min_ = data_colormap.current?.min?.valor ?? min;
    const max_ = data_colormap.current?.max?.valor ?? max;

    if (value >= min_ && value < q1) return baseColors[0];
    if (value >= q1   && value < q2) return baseColors[1];
    if (value >= q2   && value < q3) return baseColors[2];
    if (value >= q3   && value < q4) return baseColors[3];
    if (value >= q4   && value <= max_) return baseColors[4];
    return color_scale(0.5).hex();
  }

  function preparaColorMap() {
    const color_palette = chroma.scale(baseColors);
    if (!map.current || !data_colormap.current) return;

    if (legend.current) { try { map.current.removeControl(legend.current); } catch{}; legend.current = null; }
    legend.current = L.control({ position: "bottomleft" });

    legend.current.onAdd = function () {
      const div = L.DomUtil.create("div", "legend_");
      div.innerHTML += "<div>";
      let trTitulos = "<tr>", trValores = "<tr>";
      const arr = color_palette.colors(6);

      for (let index = 0; index < arr.length; index++) {
        if (index === arr.length - 1 || !data_colormap.current.min) continue;
        const valMin = parseFloat(data_colormap.current.min.valor).toFixed(0);
        const valMax = parseFloat(data_colormap.current.max.valor).toFixed(0);
        const valQ1 = parseFloat(data_colormap.current.q1.valor).toFixed(0);
        const valQ2 = parseFloat(data_colormap.current.q2.valor).toFixed(0);
        const valQ3 = parseFloat(data_colormap.current.q3.valor).toFixed(0);
        const valQ4 = parseFloat(data_colormap.current.q4.valor).toFixed(0);

        let stringTitulo = "";
        switch (index) {
          case arr.length - 1: stringTitulo = '  ' + valMax; break;
          case 0: stringTitulo = '  ' + valMin; break;
          case 4: stringTitulo = '  ' + valQ4; break;
          case 3: stringTitulo = '  ' + valQ3; break;
          case 2: stringTitulo = '  ' + valQ2; break;
          case 1: stringTitulo = '  ' + valQ1; break;
          default: break;
        }
        const td = `<td style="min-width:55px;text-align:center;padding:0 5px;background:${arr[index]};">&nbsp;</td>`;
        const tdTitulo = `<td style="min-width:55px;text-align:left;padding-right:5px;padding-left:0">${stringTitulo}</td>`;
        trTitulos += tdTitulo; trValores += td;
      }
      trTitulos += "</tr>"; trValores += "</tr>";
      div.innerHTML += `<center><div><h6 class="titulo-legend">${t("dashboard.ranking")}</h6></div></center>`;
      div.innerHTML += `<table class="tableEscala">${trTitulos}${trValores}</table>`;
      return div;
    };
    legend.current.addTo(map.current);
  }

  // ---------------------------------------------------------------
  // Render de pontos em LOTES
  // ---------------------------------------------------------------
  function addCircleMarkersBatched(points, { chunkSize = 4000, delay = 0 } = {}) {
    const schedule = window.requestIdleCallback
      ? (fn) => window.requestIdleCallback(fn)
      : (fn) => setTimeout(fn, delay);

    let i = 0;
    const group = circleLayerRef.current;
    return new Promise((resolve) => {
      function step() {
        const end = Math.min(i + chunkSize, points.length);
        for (; i < end; i++) {
          const p = points[i];
          if (!Number.isFinite(p.lat) || !Number.isFinite(p.lng)) continue;
          L.circle([p.lat, p.lng], {
            pane: 'topPane',
            radius: p.radius,
            color: p.stroke ?? p.color,
            fillColor: p.color,
            fillOpacity: p.fillOpacity ?? 0.7,
            interactive: false,
            weight: p.weight ?? 1
          }).addTo(group);
        }
        if (i < points.length) schedule(step);
        else resolve();
      }
      step();
    });
  }

  function clearCircles() { circleLayerRef.current && circleLayerRef.current.clearLayers(); }
  function clearOrigemCircles() { origemCircleLayerRef.current && origemCircleLayerRef.current.clearLayers(); }
  function clearPolylines() { polylineLayerRef.current && polylineLayerRef.current.clearLayers(); }

  // ---------------------------------------------------------------
  // Círculos/Rotas – eficiente
  // ---------------------------------------------------------------
  const carregaCircles = () => {
    if (!map.current || !dadosGenomica) return;

    const nome_var = getNomeCampoIndice();
    const zoomLevel = map.current.getZoom();

    // dataset
    const dataset = (!isAllSelect(estadoSelecionado) && Array.isArray(dadosUFGenomica) && dadosUFGenomica.length)
      ? dadosUFGenomica.filter(d => getNomeEstadoByCodIbge(d.uf_data_to_filter) === estadoSelecionado)
      : dadosGenomica;

    if (!dataset?.length) return;

    const values = dataset.map(d => d[nome_var]).filter(Number.isFinite);
    const minRank = Math.min(...values);
    const maxRank = Math.max(...values);
    const [q1,q2,q3,q4] = quintile(values);

    data_colormap.current = { min:{valor:1}, max:{valor:maxRank}, q1:{valor:q1}, q2:{valor:q2}, q3:{valor:q3}, q4:{valor:q4} };

    const colorFor = (v) => getColorForValue(v, minRank, maxRank);
    const radiusFor = (v) => {
      const base = (v - minRank) / Math.max(1e-9, (maxRank - minRank)) * 100;
      const r = Math.max(2, 100 - base);
      return r * Math.pow(2, (13 - zoomLevel));
    };

    // limpar camadas
    clearPolylines();
    clearOrigemCircles();
    clearCircles();

    // índice coord por IBGE
    const coordByIbge = new Map(dataset.map(d => [String(d.cod_ibge), [d.centroid_y, d.centroid_x]]));

    // se um estado foi escolhido: desenhar arcos e marcar origens
    const origemSet = new Set();
    if (!isAllSelect(estadoSelecionado) && Array.isArray(dadosOrigemDestino) && dadosOrigemDestino.length) {
      const codUF = [...ufLayerIndexRef.current.keys()].find(k => getNomeEstadoByCodIbge(k) === estadoSelecionado);
      const routes = dadosOrigemDestino.filter(r => String(r.ori_co_ibge).startsWith(String(codUF)));

      for (const r of routes) {
        const start = coordByIbge.get(String(r.ori_co_ibge));
        let end = coordByIbge.get(String(r.cod_ibge_muni));
        if (!start || !end) {
          const lookup = (ibge) => {
            const row = (todasCidades.current || []).find(c => String(c.COD_IBGE) === String(ibge));
            return row ? [row.Y, row.X] : null;
          };
          if (!end) end = lookup(r.cod_ibge_muni);
        }
        if (!start || !end) continue;

        const control = calculateControlPoint(+start[0], +start[1], +end[0], +end[1]);
        const bezierPath = bezierCurve(start, control, end);

        L.polyline(bezierPath, {
          color: theme === "dark" ? 'white' : 'black',
          weight: 0.8,
          opacity: 0.3
        }).addTo(polylineLayerRef.current);

        origemSet.add(String(r.ori_co_ibge));
      }

      // círculos de origem
      const origemPoints = [...origemSet].map(ibge => {
        const c = coordByIbge.get(ibge) ||
          (todasCidades.current || []).find(x => String(x.COD_IBGE) === ibge && [x.Y, x.X]);
        if (!c) return null;
        const [lat, lng] = Array.isArray(c) ? c : [c.Y, c.X];
        return { lat, lng, color:"black", stroke:"black", radius: Math.max(8, Math.pow(2,(13-zoomLevel))*50), fillOpacity:1, weight:1.2 };
      }).filter(Boolean);

      origemPoints.forEach(p => {
        L.circle([p.lat, p.lng], {
          pane: 'topPane',
          radius: p.radius,
          color: p.stroke,
          fillColor: p.color,
          fillOpacity: p.fillOpacity,
          interactive: false,
          weight: p.weight
        }).addTo(origemCircleLayerRef.current);
      });
    }

    // pontos principais em lotes
    const points = dataset.map(d => {
      const v = d[nome_var];
      return {
        lat: +d.centroid_y,
        lng: +d.centroid_x,
        color: origemSet.has(String(d.cod_ibge)) ? "black" : colorFor(v),
        stroke: origemSet.has(String(d.cod_ibge)) ? "black" : colorFor(v),
        radius: radiusFor(v),
        fillOpacity: 0.7
      };
    });
    addCircleMarkersBatched(points, { chunkSize: 4000 });

    // tooltips dos polígonos
    if (shapeFileMunicipios.current) {
      shapeFileMunicipios.current.eachLayer((layer) => {
        const cd = String(layer?.feature?.properties?.CD_MUN ?? "");
        const rec = dataset.find(x => String(x.cod_ibge) === cd);
        const nm = layer.feature?.properties?.NM_MUN;
        const uf = layer.feature?.properties?.SIGLA_UF;
        const txt = rec ? `${nm} - ${uf}<br> Ranking: ${rec[nome_var]}` : `${nm} - ${uf}`;

        if (layer.getPopup()) layer.getPopup().setContent(txt).update();
        else layer.bindPopup(txt, { autoPan:false, className:'popup-estilo-metagenomica' });

        layer.off('mouseover mousemove mouseout');
        layer.on('mouseover', (e)=> e.target.getPopup().setLatLng(e.latlng).openOn(map.current));
        layer.on('mousemove', (e)=> e.target.getPopup().setLatLng(e.latlng).openOn(map.current));
        layer.on('mouseout', function(){ this.closePopup(); });
      });
    }

    origemCircleLayerRef.current.addTo(map.current);
    polylineLayerRef.current.addTo(map.current);


    // legenda
    preparaColorMap();

    // tabela da direita (fonte)
    setDadosTabRank(dataset);
  };

  // ---------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------
  return (
    <Container className="container_Mapa">
      {loading && <div className={style.loading}><div className={style.lds_ring}><div></div><div></div><div></div><div></div></div></div>}

      <Row>
        <TabNav theme={theme} language={language} currentPage={"Metagenomica"} link_gripe="" link_zika={`${window.location.origin}/arbov`} />

        <Row>
          <div className={style.div_top}>
            <br />
            <div className={style.container_seleciona_municipio_e_cor}>
              <div className={style.seleciona_municipio}>
                {/* Estado */}
                <Autocomplete
                  {...defaultProps}
                  disableClearable
                  id="autocomplete_estado"
                  className='change_color_text'
                  isOptionEqualToValue={(option, value) => option.label === value.label}
                  value={{label: estadoSelecionado}}
                  onChange={(_, newValue) => {
                    setLoading(true);
                    clearPolylines();
                    setEstadoSelecionado(newValue.label);
                    setCod_Ibge(t("dashboard.todos"));
                    setMunicipioSelecionado(t("dashboard.todos"));
                    setTimeout(()=> setLoading(false), 60);
                  }}
                  renderInput={(params) => (
                    <TextField className='autocomplete_estado_textfield' {...params} label={t("dashboard.estado")} size="small"/>
                  )}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;

                {/* Município */}
                <Autocomplete
                  {...defaultPropsMunicipio}
                  disableClearable
                  id="autocomplete_municipio"
                  className='change_color_text'
                  isOptionEqualToValue={(option, value) => option.cod_ibge === value.cod_ibge}
                  value={{ cod_ibge: cod_ibge, label: municipioSelecionado }}
                  onChange={(_, newValue) => handleChangeMunicipioNome(newValue.cod_ibge)}
                  renderInput={(params) => (
                    <TextField {...params} label={t("dashboard.cidade")} size="small"/>
                  )}
                />

                {/* Ranking Multi-seleção */}
                <FormControl id="multipleselect_rank_form" style={{ display: indice === "mob" ? "block" : "none" }}>
                  <InputLabel>{t("dashboard.titulo_ranking")}</InputLabel>
                  <Select
                    id="multipleselect_rank_select"
                    multiple
                    value={selectedRank}
                    sx={{ width: 400 }}
                    onChange={(e) => setSelectedRank(e.target.value)}
                    input={<OutlinedInput label={t("dashboard.titulo_ranking")} />}
                    renderValue={(selected) => (
                      <Stack id="multipleselect_rank_stack" gap={1} direction="row" flexWrap="wrap">
                        {selected.map((value) => (
                          <Chip
                            id="multipleselect_rank_chip"
                            key={value}
                            label={value}
                            sx={theme === "dark" ? { color: "white", backgroundColor: "#2f3136" } : {}}
                            onDelete={() => {
                              if (value !== t("dashboard.mobilidade")) {
                                setSelectedRank(selectedRank.filter((item) => item !== value || item === t("dashboard.mobilidade")));
                              }
                            }}
                            deleteIcon={
                              <CancelIcon id="multipleselect_rank_cancelicon" onMouseDown={(event) => event.stopPropagation()} />
                            }
                          />
                        ))}
                      </Stack>
                    )}
                  >
                    {[t("dashboard.mobilidade"), t("dashboard.densidade"), "IBP", "DSEI"]
                      .filter(name => name !== t("dashboard.mobilidade"))
                      .map((name) => (
                        <MenuItem key={name} value={name} sx={{ justifyContent: "space-between" }}>
                          {name}
                          {selectedRank.includes(name) ? <img src='/flu/imagens/check.png' style={{width:'15px',height:'15px'}} alt="ok" /> : null}
                        </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        </Row>

        <div className='espacamento'></div>
        <div className={style.semanaep}>
          <Translator path="dashboard.semana_ep"/> {semanaEp}
        </div>

        <Row>
          <Col md={12}>
            <div className={style.mapa}>
              <div id="map" className={style.map} />
            </div>
          </Col>
        </Row>

        <div className='espacamento'></div>
        <div className={style.semanaep}>
          <Translator path="dashboard.semana_ep" /> {semanaEp}
        </div>
        <div className='espacamento'></div>

        {/* Tabela Rank */}
        <div className={style.table}>
          <div className={style.header_tabela}>
            <div className={style.titulo_tabela}>
              <h5><center>{!isAllSelect(estadoSelecionado) ? t("dashboard.table.titulo_rank_uf") : t("dashboard.table.titulo_rank")}</center></h5>
            </div>
            <div className={style.export_buttons}>
              <div className='divExportPlanilhaCSV'>
                <img className="exportPlanilhaCSV" src='/flu/imagens/csv_logo.gif' onClick={() => {exportToCSV("dtBasicExampleRankExport", "rank")}} alt="csv"/>
                <div className="balaoDeTextoCsv noHover">Download CSV</div>
              </div>
              <div className={style.div_export_planilha_excel}>
                <img className={style.export_planilha} src='/flu/imagens/excel_logo.gif' onClick={() => {exportToExcel("dtBasicExampleRankExport", "rank")}} alt="xlsx"/>
                <div className={style.balao_de_texto_excel}>Download XLSX</div>
              </div>
            </div>
          </div>

          <Table id={"dtBasicExampleRank"} striped bordered hover variant={theme === "dark" ? "dark" : ""}>
            <thead>
              <tr>
                <th>
                  <a href='#' style={{ color: campoOrdem === "estado" ? "cadetblue" : ""}} onClick={() => { setDecrescente(campoOrdem==="estado"?!decrescente:false); setCampoOrdem("estado"); }}>
                    <img className={theme === "dark" ? '' : style.invert} src="/flu/imagens/icones/setas-ordenadas.png" alt="ord" /> <Translator path={"dashboard.table.estado"} />
                  </a>
                </th>
                <th>
                  <a href='#' style={{ color: campoOrdem === "municipio" ? "cadetblue" : ""}} onClick={() => { setDecrescente(campoOrdem==="municipio"?!decrescente:false); setCampoOrdem("municipio"); }}>
                    <img className={theme === "dark" ? '' : style.invert} src="/flu/imagens/icones/setas-ordenadas.png" alt="ord" /> <Translator path={"dashboard.table.col1"} />
                  </a>
                </th>
                <th>
                  <a href='#' style={{ color: campoOrdem === getNomeCampoIndice() ? "cadetblue" : ""}} onClick={() => { setDecrescente(campoOrdem===getNomeCampoIndice()?!decrescente:false); setCampoOrdem(getNomeCampoIndice()); }}>
                    <img className={theme === "dark" ? '' : style.invert} src='/flu/imagens/icones/setas-ordenadas.png' alt="ord" /> <Translator path={"dashboard.ranking"} />
                  </a>
                </th>
                <th>
                  <a href='#' style={{ color: campoOrdem === "dqi" ? "cadetblue" : ""}} onClick={() => { setDecrescente(campoOrdem==="dqi"?!decrescente:false); setCampoOrdem("dqi"); }}>
                    <img className={theme === "dark" ? '' : style.invert} src='/flu/imagens/icones/setas-ordenadas.png' alt="ord" /> DQI
                  </a>
                </th>
                <th>
                  <a href='#' style={{ color: campoOrdem === "sinal_aesop_ivas" ? "cadetblue" : ""}} onClick={() => { setDecrescente(campoOrdem==="sinal_aesop_ivas"?!decrescente:false); setCampoOrdem("sinal_aesop_ivas"); }}>
                    <img className={theme === "dark" ? '' : style.invert} src='/flu/imagens/icones/setas-ordenadas.png' alt="ord" /> <Translator path={"dashboard.table.sinal_ens_atual"} />
                  </a>
                </th>
              </tr>
            </thead>
            <tbody>
              {tabelaOrdenada().map((v, i) => (
                <tr key={i}>
                  <td className={style.linha_tabela}><a href='#' onClick={() => {handleChangeEstadoTabela(v.estado)}}>{v.estado}</a></td>
                  <td className={style.linha_tabela}><a href='#' onClick={() => {handleChangeMunicipioTabela(v.cod_ibge)}}>{v.municipio}</a></td>
                  <td className={`${style.linha_tabela} ${style.numero_tabela}`}>{preparaInt(v[getNomeCampoIndice()])}</td>
                  <td className={`${style.linha_tabela} ${style.numero_tabela}`}>{preparaInt(v.dqi) === "Apto" ? t("dashboard.apto") : t("dashboard.nao_apto")}</td>
                  <td className={`${style.linha_tabela} ${style.numero_tabela}`}>{preparaInt(v.sinal_aesop_ivas)}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* tabela "oculta" só para export */}
          <Table id={"dtBasicExampleRankExport"} style={{display:"none"}} striped bordered hover variant={theme === "dark" ? "dark" : ""}>
            <thead>
              <tr>
                <th><Translator path={"dashboard.table.estado"} /></th>
                <th><Translator path={"dashboard.table.col1"} /></th>
                <th>rank_den</th><th>rank_dsei</th><th>rank_ibp</th><th>rank_mob</th>
                <th>rank_mob_den</th><th>rank_mob_den_dsei</th><th>rank_mob_den_ibp</th><th>rank_mob_den_ibp_dsei</th>
                <th>rank_mob_dsei</th><th>rank_mob_ibp</th><th>rank_mob_ibp_dsei</th>
                <th>DQI</th>
                <th><Translator path={"dashboard.table.sinal_ens_atual"} /></th>
              </tr>
            </thead>
            <tbody>
              {tabelaOrdenada().map((v,i)=>(
                <tr key={i}>
                  <td>{v.estado}</td>
                  <td>{v.municipio}</td>
                  <td>{preparaInt(v["rank_den"])}</td>
                  <td>{preparaInt(v["rank_dsei"])}</td>
                  <td>{preparaInt(v["rank_ibp"])}</td>
                  <td>{preparaInt(v["rank_mob"])}</td>
                  <td>{preparaInt(v["rank_mob_den"])}</td>
                  <td>{preparaInt(v["rank_mob_den_dsei"])}</td>
                  <td>{preparaInt(v["rank_mob_den_ibp"])}</td>
                  <td>{preparaInt(v["rank_mob_den_ibp_dsei"])}</td>
                  <td>{preparaInt(v["rank_mob_dsei"])}</td>
                  <td>{preparaInt(v["rank_mob_ibp"])}</td>
                  <td>{preparaInt(v["rank_mob_ibp_dsei"])}</td>
                  <td>{preparaInt(v.dqi) === "Apto" ? t("dashboard.apto") : t("dashboard.nao_apto")}</td>
                  <td>{preparaInt(v["sinal_aesop_ivas"])}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <div className='espacamento'></div>
        <div className='espacamento'></div>

        {/* Tabela Origem/Destino */}
        <div className={style.table}>
          <div className={style.header_tabela}>
            <div className={style.titulo_tabela}><h5><center>{t("dashboard.table.titulo_orig_dest")}</center></h5></div>
            <div className={style.export_buttons}>
              <div className='divExportPlanilhaCSV'>
                <img className="exportPlanilhaCSV" src='/flu/imagens/csv_logo.gif' onClick={() => {exportToCSV("dtBasicExample", "")}} alt="csv"/>
                <div className="balaoDeTextoCsv noHover">Download CSV</div>
              </div>
              <div className={style.div_export_planilha_excel}>
                <img className={style.export_planilha} src='/flu/imagens/excel_logo.gif' onClick={() => {exportToExcel("dtBasicExample", "")}} alt="xlsx"/>
                <div className={style.balao_de_texto_excel}>Download XLSX</div>
              </div>
            </div>
          </div>

          <Table id={"dtBasicExample"} striped bordered hover variant={theme === "dark" ? "dark" : ""}>
            <thead>
              <tr>
                <th colSpan={"2"}><center>{t("dashboard.origem")}</center></th>
                <th colSpan={"2"}><center>{t("dashboard.destino")}</center></th>
              </tr>
              <tr>
                <th>
                  <a href='#' style={{ color: campoOrdemOrigemDestino === "estado_origem" ? "cadetblue" : ""}} onClick={() => { setDecrescenteOrigemDestino(campoOrdemOrigemDestino==="estado_origem"?!decrescenteOrigemDestino:false); setCampoOrdemOrigemDestino("estado_origem"); }}>
                    <img className={theme === "dark" ? '' : style.invert} src="/flu/imagens/icones/setas-ordenadas.png" alt="ord" /> <Translator path={"dashboard.table.estado"} />
                  </a>
                </th>
                <th>
                  <a href='#' style={{ color: campoOrdemOrigemDestino === "municipio_origem" ? "cadetblue" : ""}} onClick={() => { setDecrescenteOrigemDestino(campoOrdemOrigemDestino==="municipio_origem"?!decrescenteOrigemDestino:false); setCampoOrdemOrigemDestino("municipio_origem"); }}>
                    <img className={theme === "dark" ? '' : style.invert} src="/flu/imagens/icones/setas-ordenadas.png" alt="ord" /> <Translator path={"dashboard.table.col1"} />
                  </a>
                </th>
                <th>
                  <a href='#' style={{ color: campoOrdemOrigemDestino === "estado_destino" ? "cadetblue" : ""}} onClick={() => { setDecrescenteOrigemDestino(campoOrdemOrigemDestino==="estado_destino"?!decrescenteOrigemDestino:false); setCampoOrdemOrigemDestino("estado_destino"); }}>
                    <img className={theme === "dark" ? '' : style.invert} src="/flu/imagens/icones/setas-ordenadas.png" alt="ord" /> <Translator path={"dashboard.table.estado"} />
                  </a>
                </th>
                <th>
                  <a href='#' style={{ color: campoOrdemOrigemDestino === "municipio_destino" ? "cadetblue" : ""}} onClick={() => { setDecrescenteOrigemDestino(campoOrdemOrigemDestino==="municipio_destino"?!decrescenteOrigemDestino:false); setCampoOrdemOrigemDestino("municipio_destino"); }}>
                    <img className={theme === "dark" ? '' : style.invert} src="/flu/imagens/icones/setas-ordenadas.png" alt="ord" /> <Translator path={"dashboard.table.col1"} />
                  </a>
                </th>
              </tr>
            </thead>
            <tbody>
              {tabelaOrdenadaOrigemDestino().map((v,i)=>(
                <tr key={i}>
                  <td className={style.linha_tabela}><a href='#' onClick={() => {handleChangeEstadoTabela(v.estado_origem)}}>{v.estado_origem}</a></td>
                  <td className={style.linha_tabela}><a href='#' onClick={() => {handleChangeMunicipioTabela(v.cod_ibge_origem)}}>{v.municipio_origem}</a></td>
                  <td className={style.linha_tabela}><a href='#' onClick={() => {handleChangeEstadoTabela(v.estado_destino)}}>{v.estado_destino}</a></td>
                  <td className={style.linha_tabela}><a href='#' onClick={() => {handleChangeMunicipioTabela(v.cod_ibge_destino)}}>{v.municipio_destino}</a></td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Row>

      {/* Footer com data do cache */}
      <Row><div className='espacamento'></div><div className='espacamento'></div></Row>
      <Row><div className={style.semanaep}>{dataCache}</div></Row>
    </Container>
  );
};

export default Metagenomica;
